import { Rule } from 'antd/lib/form';
import FormInput from 'components/Input/FormInput';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

interface IMerchantNameField {
	settingsId: string;
	onChange: (value: string) => void;
}

const MerchantNameField: React.FC<IMerchantNameField> = ({ onChange, settingsId }) => {
	const { t } = useTranslation('error');

	const validationRules = useMemo<Rule[]>(() => [{ required: true, message: t('enterMerchantName') }], [t]);

	return (
		<FormInput
			testId="MerchantNameField"
			name={`merchantName-${settingsId}`}
			label="merchantNameLabel"
			onChange={onChange}
			validationRules={validationRules}
		/>
	);
};

export default React.memo(MerchantNameField);
